// extracted by mini-css-extract-plugin
export default {"vertical_align":"socials_vertical_align__ceTPx","items_div":"socials_items_div__uloEX","item_div":"socials_item_div__6Vadb","item_div_icon":"socials_item_div_icon__IDBR6"};